(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-coaching-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (!(event.target instanceof Element)) return;
  const card = event.target.closest('.ascoach a[data-as-goal]');
  if (!card) return;
  const form = card.closest('.ascoach').querySelector('#ASCoachingInquiry');
  const select = form?.querySelector('#ContactFocus');
  if (!select) return;
  const option = Array.from(select.options).find((item) => item.dataset.asGoal === card.dataset.asGoal);
  if (!option) return;
  select.value = option.value;
  select.dispatchEvent(new Event('input', { bubbles: true }));
  select.dispatchEvent(new Event('change', { bubbles: true }));
  form.focus({ preventScroll: true });
});

function asSyncAthleteField(form) {
  const select = form?.querySelector('#ContactFocus');
  const field = form?.querySelector('[data-as-athlete-field]');
  const input = field?.querySelector('input');
  if (!select || !field || !input) return;
  const isAthlete = select.selectedOptions[0]?.dataset.asGoal === 'performance';
  field.hidden = !isAthlete;
  input.disabled = !isAthlete;
}

document.addEventListener('change', (event) => {
  if (!(event.target instanceof Element) || !event.target.matches('.ascoach #ContactFocus')) return;
  asSyncAthleteField(event.target.closest('form'));
});

const asInquiryObservers = new WeakMap();

function asObserveInquiry(root = document) {
  const section = root.matches?.('.ascoach') ? root : root.querySelector('.ascoach');
  if (!section) return;
  const form = section.querySelector('#ASCoachingInquiry');
  const select = form?.querySelector('#ContactFocus');
  const requestedGoal = new URLSearchParams(window.location.search).get('ziel');
  const goalOption = Array.from(select?.options || []).find((option) => option.dataset.asGoal && option.dataset.asGoal === requestedGoal);
  if (goalOption && !select.value) {
    select.value = goalOption.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }
  asSyncAthleteField(form);
  if (asInquiryObservers.has(section) || !('IntersectionObserver' in window)) return;
  const bar = section.querySelector('.mobile-cta');
  if (!form || !bar) return;
  const observer = new IntersectionObserver((entries) => {
    bar.hidden = entries.some((entry) => entry.isIntersecting);
    if (bar.hidden && bar.contains(document.activeElement)) form.focus({ preventScroll: true });
  }, { rootMargin: '-120px 0px 0px 0px', threshold: 0 });
  observer.observe(form);
  asInquiryObservers.set(section, observer);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => asObserveInquiry(), { once: true });
} else {
  asObserveInquiry();
}

document.addEventListener('shopify:section:load', (event) => asObserveInquiry(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target.matches?.('.ascoach') ? event.target : event.target.querySelector('.ascoach');
  if (!section) return;
  asInquiryObservers.get(section)?.disconnect();
  asInquiryObservers.delete(section);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
